const getters = {
  commitToolBar({ commit }, data) {
    commit("setToolData", data);
    commit("setCacheView", data);
  },
  clearToolBar({ commit }, data) {
    commit("clearToolItem", data.detail);
  },
  clearCache({ commit }, data) {
    commit("clearCacheView", data);
  },
  clearCacheOther({ commit }, data) {
    commit("clearCacheOther", data);
  },
  clearCacheAll({ commit }) {
    commit("clearCacheAll");
  },
  addOrderCount({ commit }, data) {
    commit("addOrderCount", data);
  },
  // async getreadCount({commit}){
  //   try {
  //   const { date } = await topBarUnreadCount()
  //   commit('updateUnreadCount',date)
  //   console.log('获取未读消息成功123',count);
  //   return Promise.resolve(data)
    
  //   } catch (error) {
  //   console.log('获取未读消息失败',error);
    
  //   }
  // }
};
export default getters;
